module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r3n1r2r-4b9a7e4a666523efd8fdd3a5a5357a4f.svg";